<template>
	<div class="row">
		<div class="col-12 mb-3">
			<label class="text-muted">Subject*</label>
			<input type="text" class="form-control"  v-model="subject" />
		</div>
		<div class="col-12 mb-3">
			<label class="text-muted">Message*</label>
			<textarea rows="5"  class="form-control" v-model="message" wrap="hard" />
		</div>

		<div class="col-12 mb-5" align="right">
			<button class="btn btn-primary col-6 btn-lg" :disabled="!isFormValid||isBusy" @click="btnContinueClick">
				<span v-show="!isBusy">Send Message</span>
				<div class="spinner-border text-light" role="status" v-show="isBusy">
					<span class="sr-only">Sending...</span>
				</div>
			</button>
		</div>
	</div>
</template>
<script>
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const fb = require("../firebaseConfig")

export default {
	name: "SendMessageForm",
	components: {

	},
	props:["mailingList"],
    computed:{
		confId(){
            return this.$store.state.confId
        },
        confName(){
            return this.$store.state.confName
        },
        confInfo(){
            return this.$store.state.confInfo
        },
        confList(){
			return this.$store.state.confList
        },
        confData(){
            return Array.isArray(this.confList) && this.confList.length > 0 ? this.confList.filter((c) => c.id === this.confId )[0].data : {}
        },
        filterTickets(){
            if(this.confTickets === "" && this.confPaymentStatus == "") return this.registrations;
			if(this.confTickets !== "" && this.confPaymentStatus !== ""){
				return this.registrations.filter((r) => r.data.confticketid === this.confTickets && r.data.status === this.confPaymentStatus);
			}else{
				if(this.confTickets !== "") return this.registrations.filter((r) => r.data.confticketid === this.confTickets);
				if(this.confPaymentStatus !== "") return this.registrations.filter((r) => r.data.status === this.confPaymentStatus);
			}

			return this.registrations;
        },
        userProfile(){
            console.log(this.$store.state.userProfileDoc)
            return this.$store.state.userProfile
        },
		isFormValid(){
			if(this.subject.length < 10){
				return false;
			}
			if(this.message.length < 50){
				return false;
			}
            return true
        }
    },
    data(){
        return{
			isBusy: false,
			register:{},
			subject: "",
			message: "",
        }
    },
    methods:{
		btnContinueClick(){
			this.isBusy = true;
			this.mailingList.forEach((email) => {
				fb.adminEmailCollection.add({
					to: `${email.data.fname} ${email.data.lname}<${email.data.email}>`,
					message:{
						subject: this.subject,
						html:`<p>Dear ${email.data.fname},</p>
						<p>${this.message}</p>
						<p>&nbsp;</p>
						<p>&nbsp;</p>
						<p>&nbsp;</p>
						<p>&nbsp;</p>
						<p><hr/></p>
						<p style="font-size:10px;">${this.confInfo.confhost}</p>`,
					},
				}).then(()=>{
					Vue.$toast.success("Message sent.", {position:"top"})
					this.isBusy = false;
					this.subject = "";
					this.message = "";
				}).catch((error) => {
					console.error("Error writing document: ", error);
					this.isBusy = false;
				})
			})
		},
    },
    mounted(){
		console.log(this.mailingList);
    }
}
</script>
